<script setup lang="ts">
import Select from 'primevue/select';
import type { IElement } from '~/interfaces/form/formBuilder';
import { generateTranslationKey } from '~/utilities/data-transformers';
defineProps<{
  element: IElement;
  formErrors: { [key: string]: string };
}>();
const { $t } = useNuxtApp();
const site = useSiteStore();
const emits = defineEmits<{
  (e: 'inputChange', id: string): void;
}>();
const model = defineModel<string>();
const container = ref<HTMLDivElement>();
const containerWidth = computed(() => `${container.value?.clientWidth}`);
</script>
<template>
  <div ref="container" class="w-full relative">
    <label :for="element.id" class="text-base-priority text-xs pl-1">
      {{
        $t(
          `label.${generateTranslationKey(element.label)}-${site.getRegionCode}`,
          `label.${generateTranslationKey(element.label)}`,
        )
      }}
    </label>
    <Select
      v-model="model"
      :input-id="element.id"
      :options="element.items"
      :placeholder="
        $t(
          `placeholder.${element.placeholder}-${site.getRegionCode}`,
          `placeholder.${element.placeholder}`,
        )
      "
      :disabled="element.disabled"
      :invalid="!!formErrors[element.id]"
      :name="element.id"
      option-label="label"
      label-class="capitalize"
      option-value="value"
      append-to="body"
      class="w-full"
      :width="containerWidth"
      :pt:optionLabel="'capitalize'"
      @change="emits('inputChange', element.id)"
    />
  </div>
</template>
